<script>
	// Constants
	import { PromotionsType } from '@/Constants/Promotions';
	// Partials
	import List from '@/Partials/Promotions/_List.svelte';

	// eslint-disable-next-line no-unused-vars
	let updatePromotion = false;
	let selectedPromotion = null;

	let listComponent;
</script>

<div>
	<div class="flex">
		<List
			bind:selectedPromotion
			promotionType={PromotionsType.SGMBonusBack}
			bind:this={listComponent}
			on:selected={() => {
				updatePromotion = true;
			}}
		/>
	</div>
</div>
